import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { AttendanceWhisperFieldComponent } from './attendance-whisper-field.component';
import { AttendanceWhisperComponent } from './attendance-whisper.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    AttendanceWhisperComponent,
    AttendanceWhisperFieldComponent,
  ],
  exports: [
    AttendanceWhisperComponent,
    AttendanceWhisperFieldComponent,
  ],
})
export class AttendanceWhisperModule { }
